<template>
  <div class="">
    <div class="">
      <template v-for="(_, i) in formValues">
        <div class="flex mb-[15px]">
          <div class="dropdown bg-gray text-black w-1/3">
            <select
              class="w-full text-[14px] !px-[20px] !py-[12px] !border-none !bg-gray"
              name="license_categories[]"
              v-model="formValues[i].category"
            >
              <option value="" selected="" disabled="">選択してください</option>
              <template v-for="o in makeOptions(formValues[i].category)">
                <option :value="o.id">{{ o.name }}</option>
              </template>
            </select>
          </div>
          <input
            type="text"
            class="border border-solid border-gray-line rounded-md | px-[2rem] py-[1rem] text-[1.4rem] | placeholder:text-black-place-holder ml-[10px] w-1/3"
            placeholder="認定番号を入力してください"
            name="license_numbers[]"
            v-model="formValues[i].number"
          />
          <button
            type="button"
            class="flex items-center border border-solid border-[#D2D2D2] rounded-full relative block w-[39px] h-[39px] transform rotate-45 ml-[10px]"
            @click="removeForm(i)"
          >
            <i
              class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[2px] h-[16px] bg-[#999999] "
            />
            <i
              class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[16px] h-[2px] bg-[#999999]"
            />
          </button>
        </div>
      </template>
    </div>
    <button
      type="button"
      class="flex items-center border border-solid border-[#D2D2D2] rounded-full px-[20px] inline-block"
      @click="addForm"
    >
      <span class="relative inline-block w-[16px] h-[16px] mr-[10px]">
        <i
          class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[2px] h-[16px] bg-[#999999] "
        />
        <i
          class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[16px] h-[2px] bg-[#999999]"
        />
      </span>
      <span class="text-[#6E6E6E] text-[13px]">資格を追加</span>
    </button>
  </div>
</template>

<script>
const makeformValue = () => ({ category: '', number: '' });

export default {
  props: {
    licenseCategories: Array,
    selectLicenseCategories: Array,
    inputLicenseNumber: Array,
  },
  data() {
    return {
      formValues: [
        ...this.selectLicenseCategories.map((category, i) => ({
          category,
          number: this.inputLicenseNumber[i],
        })),
        makeformValue(),
      ],
    };
  },
  computed: {
    selectedCategories() {
      return this.formValues.map(({ category }) =>
        category === '' ? -1 : Number(category)
      );
    },
  },
  methods: {
    makeOptions(categoryid) {
      return this.licenseCategories.filter(
        ({ id }) => id == categoryid || !this.selectedCategories.includes(id)
      );
    },
    addForm() {
      this.formValues = [...this.formValues, makeformValue()];
    },
    removeForm(index) {
      this.formValues = [
        ...this.formValues.slice(0, index),
        ...this.formValues.slice(index + 1),
      ];
    },
  },
};
</script>

*------------------------ 使用手順 ------------------------*

<!-- <template>
     <ul class="item_list" id="item_list">
     <li class="inline-flex justify-start_block" v-for="(item, index) in licenseList" v-bind:key="index">
     <select name="license_categories[]" v-model="item.category" style="width:50%">
     <option value="">選択してください</option>
     <option v-for="(category, innerIndex) in licenseCategories" v-bind:value="category.id" v-bind:key="innerIndex">{{ category.name }}</option>
     </select>
     <input class="text-[13px] tracking-[0.1em] leading-[1.5em] ml-[5px]" style="width:40%" type="text" name="license_numbers[]" v-model="item.number" placeholder="認定番号を入力してください">
     <button class="ml-[5px]" v-on:click="deleteItem(index)" type="button">削除</button>
     </li>
     </ul>
     </template>

     <script>

     export default {
     props: ['licenseCategories', 'selectLicenseCategories', 'inputLicenseNumber', 'addButtonId'],
     data() {
     const {licenseCategories, selectLicenseCategories, inputLicenseNumber, addButtonId} = this
     console.log({licenseCategories, selectLicenseCategories, inputLicenseNumber, addButtonId})
     return {
     licenseList:[],
     };
     },
     methods: {
     addItem()
     {
     this.licenseList.push({category:'',number:''});
     },
     deleteItem(index)
     {
     this.licenseList.splice(index, 1);
     },
     },
     mounted() {
     var limit = this.selectLicenseCategories.length
     var inputNumberLength = this.inputLicenseNumber.length
     if (inputNumberLength > limit){
     limit = inputNumberLength
     }

     for (let index = 0; index < inputNumberLength; index++) {
     let licenseObject = {category:'',number:''};

     licenseObject.category = this.selectLicenseCategories[index] ?? ''
     licenseObject.number = this.inputLicenseNumber[index] ?? ''

     this.licenseList.push(licenseObject);
     }

     if (this.licenseList.length == 0){
     this.licenseList.push({category:'',number:''});
     }

     document.querySelector('#add_selecter').addEventListener('click', this.addItem)
     }
     };
     </script> -->
